/* eslint-disable @typescript-eslint/member-ordering */
import {computed, makeObservable, observable} from "mobx";
import {JsonObject, JsonProperty} from "typescript-json-serializer";
import {AbstractModel} from "./abstract-model";


export interface ParcelProps {
    objectId?: number;
    guid?: string;
    egrid?: string;
    nr?: string;
    municipality?: string;
    creator?: string;
    createdAt?: Date;
    editor?: string;
    updatedAt?: Date;
}

/**
 * Gemeinden
 */
@JsonObject()
export class Parcel extends AbstractModel {

    static readonly comparableAttributes: string[] = [
        "egrid", "nr", "municipality"
    ];

    // workaround, because feature template doesn't seem to work for table features
    static readonly prototypeAttributes: string[] = [
        "guid", "egris_egrid", "nummer", "gemeinde"
    ];

    // field mappings
    static readonly databaseFieldNames: Map<string, string> = new Map<string, string>([
        ["objectId", "objectid"],
        ["egrid", "egris_egrid"],
        ["nr", "nummer"],
        ["municipality", "gemeinde"]
    ]);

    class = "Parcel";
    typeLabel = "Liegenschaft";

    static sortByName(a: Parcel, b: Parcel) {
        const nameA = a.egrid;
        const nameB = b.egrid;
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }

        // names must be equal
        return 0;
    }

    /**
     * !!! Use egris egrid as guid !!!
     */
    @JsonProperty({name: "egris_egrid"})
        guid: string;

    /**
     * AGRIS EGRID
     */
    @JsonProperty({name: "egris_egrid"})
        egrid: string;

    /**
     * Number
     */
    @JsonProperty({name: "nummer"})
        nr: string;

    /**
     * Gemeinde
     */
    @JsonProperty({name: "gemeinde"})
        municipality: string;

    constructor(props?: ParcelProps) {
        super();
        if (props) {
            Object.assign(this, props);
        }
        // make observable after setting properties to avoid 'strict' messages
        makeObservable(this, {
            objectId: observable, // do observe to reload when object is saved
            guid: observable,
            egrid: observable,
            nr: observable,
            municipality: observable,

            isAlterable: computed,

            creator: observable,
            createdAt: observable,
            editor: observable,
            updatedAt: observable,
            isNewRecord: computed
        });
    }

    get comparableAttributes(): string[] {
        return Parcel.comparableAttributes;
    }

    get isAlterable(): boolean {
        return true;
    }
}
